import React from "react";
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

export default function RenderAvgOdo({result, total = 5, legend}){
  
      const RADIAN = Math.PI / 180;

      //data for te color legend (the color indicators in the back of the tacometer, not the needle itself)
      const data = [
        { name: '< 60%', value: 108, color: '#FE4242' },
        { name: '69% <x< 89%', value: 36, color: '#FEDF63' },
        { name: '>= 90%', value: 18, color: '#9CD841' },
        
        //{ name: 'Detractores', value: 25, color: '#0000ff' },
      ];

      const cx = 130;
      const cy = 110;
      const iR = 70;
      const oR = 90;

      //converts your result in % for a standard way to show the result and the color legend
      const value = result.average*180/total;
      
      const roundedValue = value.toFixed(2);
      const roundedResult = Math.round(result.average) 
      const n = result.n;

      

      const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip">

              <p className="label">{`${payload[0].name}`}</p>
              
        
            </div>
          );
        }
      
        return null;
      };

      const AvgResultBox = () => {
        
          return (
            <div className={`  p-2  
                

            `}>

              <p className="text-xs font-light text-slate-700 text-center m-0">{legend || `Resultado: `} <strong className="font-semibold">{roundedResult}%</strong>
              <br/><span className="text-[10px] font-light text-slate-700 m-0">Basado en {n} evaluaciones completadas.</span>

              </p>
              
        
            </div>
          );
        
      
        
      };      

      const needle = (value, data, cx, cy, iR, oR, color) => {

        //let total_dial = 0;
        let total_dial = 180;
        data.forEach((v) => {
        //  total_dial += v.value;
        });
        
        const ang = 180.0 * (1 - value / total_dial);
        //const ang = 180.0 * value / 100 ;
        const length = (iR + 2 * oR) / 3;
        const sin = Math.sin(-RADIAN * ang);
        const cos = Math.cos(-RADIAN * ang);
        const r = 5;
        const x0 = cx + 5;
        const y0 = cy - 5;
        const xba = x0 + r * sin;
        const yba = y0 - r * cos;
        const xbb = x0 - r * sin;
        const ybb = y0 + r * cos;
        const xp = x0 + length * cos;
        const yp = y0 + length * sin;

        return [
          <circle key="circle-1234" cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
          <path key="path-1234" d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="#none" fill={color} />,
        ];

      };

    
      
    
    return(
          <div className="">
            {
                result.average !== 0 ? (

                    <>
                        <PieChart width={cx*2} height={cy}>
                            <Pie
                                dataKey="value"
                                startAngle={180}
                                endAngle={0}
                                data={data}
                                cx={cx}
                                cy={cy}
                                innerRadius={iR}
                                outerRadius={oR}
                                fill="#8884d8"
                                stroke="none"
                                >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                                {needle(value, data, cx, cy, iR, oR, ' #9BA0A7')}
                                <Tooltip content={<CustomTooltip />}/>
                                
                        </PieChart>
                        <AvgResultBox result={roundedResult} />
                    </>

                ) : (
                    <p className="pt-2 pl-2 text-[10px] font-light">0 registros</p>
                )


            }
            
              
          </div>
    );
    
     
    
    }//end avg_odo